import {
  createDomainApi,
  type ExtractEntityType,
  type ExtractInputType,
} from '@skylabs-digital/react-proto-kit';
import { providerConfigInputSchema, providerConfigSchema } from '../schemas/providerConfig.schema';

// `GET /provider-configs` returns `{ success, data: [...] }` with NO
// pagination `meta` (see backend/src/api/provider-configs/routes.ts —
// `successResponse(configs.map(formatConfig))`, not `paginationResponse`).
// `UseListResult.meta` is optional in react-proto-kit (`meta?: PaginationMeta`)
// so `createDomainApi(...).useList()` tolerates the unpaginated shape without
// extra config — the same pattern already used by `rateLimits.api.ts` against
// an equally unpaginated list endpoint.
export const providerConfigsApi = createDomainApi(
  'provider-configs',
  providerConfigSchema,
  providerConfigInputSchema,
);

export type ProviderConfigEntity = ExtractEntityType<typeof providerConfigsApi>;
export type ProviderConfigInputType = ExtractInputType<typeof providerConfigsApi>;
